// src/utils/navigation.js
export const goBack = (navigate, fallbackPath = '/profile') => {
  if (window.history.length > 1) {
    navigate(-1);
  } else {
    navigate(fallbackPath);
  }
};